import { useSelector } from 'react-redux';
import { Modal } from '@pmi/dsm-react';
import { useDeleteUser2FANumberMutation } from './apiSlice';
import styles from './deleteUserPhoneNumber.module.scss';
import { toastWithAnalytics } from '../../../../../../shared/analytics';
import { accountSelector } from '../../../../../../shared/store/shared/accountSlice';

interface DeleteUserPhoneNumberProps {
  accountUserId: string;
  onCancel?: () => void;
  onSuccess?: () => void;
}

export default function DeleteUser2FANumberModal({
  accountUserId,
  onCancel = () => {},
  onSuccess = () => {},
}: DeleteUserPhoneNumberProps) {
  const [deletePhoneNumber, deletedPhoneNumber] =
    useDeleteUser2FANumberMutation();
  const { currentAccountId } = useSelector(accountSelector);

  const onRemove = async () => {
    deletePhoneNumber({ accountId: currentAccountId, accountUserId })
      .unwrap()
      .then(() => {
        toastWithAnalytics(
          'The phone number was removed successfully',
          'success',
        );
        onSuccess();
        onCancel();
        deletedPhoneNumber.reset();
      })
      .catch(() => {
        toastWithAnalytics(
          'There was an error removing the phone number',
          'danger',
        );
        deletedPhoneNumber.reset();
      });
  };
  const onCancelHandler = () => {
    onCancel();
  };

  return (
    <Modal
      show
      onClose={onCancelHandler}
      headline="Remove?"
      description=""
      customClassName={`${styles['remove-phone-number-modal']}`}
      headline_description="Are you sure you want to remove this phone number? This action cannot be undone."
      buttons={[
        {
          titleText: 'Cancel',
          variant: 'outline-secondary',
          onClick: onCancelHandler,
          disabled: deletedPhoneNumber.isLoading,
        },
        {
          titleText: 'Yes, Remove',
          variant: 'primary',
          onClick: onRemove,
          disabled: deletedPhoneNumber.isLoading,
        },
      ]}
    />
  );
}
